import {useGate, useUnit} from 'effector-react';
import {useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {actions} from 'reducers';
import i18n from 'utils/localization/i18n';
import {TJSonTextTranslation} from 'utils/localization/types';

import {$calltechHost, ConfigsGate} from '../models';

import {CalltechCall, useCalltechBridge} from './useCalltechBridge';
import {useTypedParams} from './useQueryParams';

export const useSetupForm = () => {
    const [storeReady, setStoreReady] = useState(false);
    const {lang, phone} = useTypedParams();
    const dispatch = useDispatch();

    const calltechHost = useUnit($calltechHost);

    const handleCalltechCall = useCallback((lastCall: CalltechCall) => {
        dispatch(actions.setAppInfo({
            callInfo: {
                ...lastCall.info,
                endTime: lastCall.isEnded ? Date.now() : undefined,
            },
            mockPhone: {phone: lastCall.info.phone},
            call: {
                isEnded: lastCall.isEnded,
                isHold: lastCall.onHold,
                isMuted: lastCall.isMuted,
                isOutgoing: lastCall.isOutgoing,
            },
        }));
        setStoreReady(true);
    }, [dispatch]);

    useCalltechBridge({
        calltechHost,
        phone,
        onCall: handleCalltechCall,
    });

    useEffect(() => {
        window.serverData.lang = lang || 'ru';
        i18n.import(window.translations as TJSonTextTranslation, lang || 'ru');
        delete window.translations;
    }, [lang]);

    useGate(ConfigsGate);

    return {isReady: Boolean(calltechHost && storeReady)};
};
